import Skeleton from "@mui/material/Skeleton";
import FlexColumn from "shared/components/Layout/components/FlexColumn";

const SkeletonBroadcastContent = () => {
  return (
    <FlexColumn rowGap={"0.5rem"}>
      <Skeleton
        variant="text"
        sx={{
          height: 20,
          width: 30,
          transform: "none",
        }}
      />
      <Skeleton
        sx={{
          height: 40,
          borderRadius: "0.5rem",
          transform: "none",
        }}
      />
      <Skeleton
        variant="text"
        sx={{
          height: 20,
          width: 30,
          transform: "none",
        }}
      />
    </FlexColumn>
  );
};

export default SkeletonBroadcastContent;
